



















































import { Component, Prop, Vue } from 'vue-property-decorator';
import Grid from '../../components/grid/Grid.vue';
import GridColumn from '../../components/grid/GridColumn.vue';
import FilterForm from '../donors/Filter.vue';

@Component({
  components: {
    'grid': Grid,
    'grid-column': GridColumn,
    'filter-form': FilterForm,
  },
})
export default class RelativeDonorsTab extends Vue {

  @Prop({ default: null })
  public patient: any;

  get kinshipTypes() {
    return [{ color: '#8DD3C7', class: ' mother', name: this.$t('Мать'), title: 'Материнский', hapl: 'Hapl 1' },
            { color: '#ffc107', class: ' father', name: this.$t('Отец'), title: 'Отцовский', hapl: 'Hapl 2' }];
  }

  get haplotypesCalculated() {
    return this.haplotypes && this.haplotypes.firstAlleleColor && this.haplotypes.secondAlleleColor;
  }

  get canCalculateHaplotypes() {
    const kinships = this.kinshipTypes.map(m => m.name);
    return this.patient.donorsRelative.filter(f => kinships.includes(f.kinshipName) &&
                                                   this.donorHasFilledAlleles(f)).length === kinships.length &&
    this.patient.hlas.filter(f => this.trimHla(f.firstAllele).length > 0 &&
                                  this.trimHla(f.secondAllele).length > 0).length >= 5;
  }

  get displayHaplotypesWarning() {
    const kinships = this.kinshipTypes.map(m => m.name);
    const parents = this.patient.donorsRelative.filter(f => kinships.includes(f.kinshipName));
    const hasBothParents = parents.length === kinships.length;
    if (hasBothParents) {
      return this.patient.hlas.filter(f => this.trimHla(f.firstAllele).length > 0 &&
                                          this.trimHla(f.secondAllele).length > 0).length < 5 ||
            parents.filter(f => this.donorHasFilledAlleles(f)).length < parents.length || !this.haplotypesCalculated;
    } else {
      return false;
    }
  }

  get haplotypes() {
    if (!this.canCalculateHaplotypes) {
      return null;
    }
    const haplotypes = {
      firstAlleleColor: '',
      firstAlleleTitle: '',
      secondAlleleColor: '',
      secondAlleleTitle: '',
    };
    for (const donor of this.patient.donorsRelative) {
      for (const kinship of this.kinshipTypes) {
        if (donor.kinshipName === kinship.name) {
          if (this.compareAlleles('firstAllele', donor, 1)) {
                haplotypes.firstAlleleColor = kinship.color;
                haplotypes.firstAlleleTitle = kinship.title;
                donor.firstAlleleClass = kinship.class;
          } else if (this.compareAlleles('firstAllele', donor, 2)) {
                haplotypes.firstAlleleColor = kinship.color;
                haplotypes.firstAlleleColor = kinship.title;
                donor.secondAlleleClass = kinship.class;
          } else if (this.compareAlleles('secondAllele', donor, 1)) {
                haplotypes.secondAlleleColor = kinship.color;
                haplotypes.secondAlleleTitle = kinship.title;
                donor.firstAlleleClass = kinship.class;
          } else if (this.compareAlleles('secondAllele', donor, 2)) {
                haplotypes.secondAlleleColor = kinship.color;
                haplotypes.secondAlleleTitle = kinship.title;
                donor.secondAlleleClass = kinship.class;
          }
        }
      }
    }
    return haplotypes;
  }

  public compareAlleles(patientAlleleIndex, donor, donorAlleleIndex) {
    return this.trimHla(this.patient.hlas[0][patientAlleleIndex]) === this.trimHla(donor['a' + donorAlleleIndex]) &&
           this.trimHla(this.patient.hlas[1][patientAlleleIndex]) === this.trimHla(donor['b' + donorAlleleIndex]) &&
           this.trimHla(this.patient.hlas[2][patientAlleleIndex]) === this.trimHla(donor['c' + donorAlleleIndex]) &&
           this.trimHla(this.patient.hlas[3][patientAlleleIndex]) === this.trimHla(donor['dqb1' + donorAlleleIndex]) &&
           this.trimHla(this.patient.hlas[4][patientAlleleIndex]) === this.trimHla(donor['drb1' + donorAlleleIndex]) &&
           this.trimHla(this.patient.hlas[5][patientAlleleIndex]) === this.trimHla(donor['dpb1' + donorAlleleIndex]);
  }

  public trimHla(allele) {
    return (allele || '').replaceAll('_', '').replace(new RegExp(':$'), '');
  }

  public donorHasFilledAlleles(donor) {
    return this.trimHla(donor.a1).length > 0 && this.trimHla(donor.a2).length > 0 &&
           this.trimHla(donor.b1).length > 0 && this.trimHla(donor.b2).length > 0 &&
           this.trimHla(donor.c1).length > 0 && this.trimHla(donor.c2).length > 0 &&
           this.trimHla(donor.dqb11).length > 0 && this.trimHla(donor.dqb12).length > 0 &&
           this.trimHla(donor.drb11).length > 0 && this.trimHla(donor.drb12).length > 0;
  }

  public getEditLink(row: any) {
    return `/donorsRelative/${row.id}/`;
  }

  public getDonorHaplotypeClass(donor, allele) {
    if (this.haplotypesCalculated) {
      return allele === 1 ? donor.firstAlleleClass : donor.secondAlleleClass;
    }
    return '';
  }
}
